module.exports = __webpack_public_path__ + "static/media/sn_ab_ldbrd3.b42ae238.jpg";